import {
    ComChanRequestV1,
    ComChanResponseV1,
    ComChanVersion,
    GeoApp,
} from 'api'

var comchan_version: ComChanVersion = 'v1'
var comchan_request_count = 0

type ComChanResponseV1Callback = (body: ComChanResponseV1['body']) => void

var comchan_pending_v1: { [rqid: string]: ComChanResponseV1Callback } = {}

function on_comchan_response_v1(msg: ComChanResponseV1) {
    comchan_version = 'v1'

    let kind = msg.body.kind
    if (kind == 'set_version') return

    let cb = comchan_pending_v1[msg.rqid]
    if (!cb) return
    cb(msg.body)
}

function on_comchan_response(msg: ComChanResponseV1) {
    console.log('on res:', JSON.stringify(msg))

    if (msg.version == 'v1') return on_comchan_response_v1(msg)

    console.error('invalid message version. only v1 is allowed')
}

if (typeof globalThis.GOOJE_BRIDGE == 'object' && globalThis.GOOJE_BRIDGE) {
    globalThis.GOOJE_BRIDGE.onmessage = ev => {
        on_comchan_response(JSON.parse(ev.data))
    }
}

globalThis.GoojeNative = {
    on_response(message) {
        on_comchan_response(message)
    },
}

if (globalThis.GOOJE_BRIDGE) {
    console.log('sending version req')
    globalThis.GOOJE_BRIDGE.postMessage('version_request')
}

function random_string(): string {
    const ABC = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    let output = ''
    for (let i = 0; i < 16; i++) {
        output += ABC[(Math.random() * ABC.length) | 0]
    }
    return output
}

function comchan_request_v1(
    body: ComChanRequestV1['body'],
    callback: ComChanResponseV1Callback
): boolean {
    if (!globalThis.GOOJE_BRIDGE) return false

    comchan_request_count++
    let rq: ComChanRequestV1 = {
        version: 'v1',
        rqid: `${random_string()}-${comchan_request_count}-${
            (performance.now() * 1000) | 0
        }`,
        body,
    }

    globalThis.GOOJE_BRIDGE.postMessage(JSON.stringify(rq))

    let timeout = setTimeout(() => {
        delete comchan_pending_v1[rq.rqid]
        console.warn(`comchan request timeout: ${rq.body.kind}`)
        callback({ kind: 'timeout' })
    }, 3e3)

    comchan_pending_v1[rq.rqid] = body => {
        clearTimeout(timeout)
        callback(body)
    }

    return true
}

type PushNotificationParams = {
    title: string
}
export async function native_push_notification({
    title,
}: PushNotificationParams): Promise<boolean | null> {
    return new Promise(resolve => {
        if (!globalThis.GOOJE_BRIDGE) return resolve(null)

        let sended = false
        if (comchan_version == 'v1') {
            sended = comchan_request_v1(
                { kind: 'push_notification', title },
                res => {
                    resolve(res.kind == 'ok')
                }
            )
        }
        if (!sended) resolve(null)
    })
}

export async function native_theme_get(): Promise<'dark' | 'light' | null> {
    return new Promise(resolve => {
        if (!globalThis.GOOJE_BRIDGE) return resolve(null)

        let sended = false
        if (comchan_version == 'v1') {
            sended = comchan_request_v1({ kind: 'theme_get' }, res => {
                if (res.kind == 'theme') {
                    resolve(res.dark_mode ? 'dark' : 'light')
                } else {
                    resolve(null)
                }
            })
        }
        if (!sended) resolve(null)
    })
}

export async function native_theme_set(
    theme: 'dark' | 'light'
): Promise<boolean | null> {
    return new Promise(resolve => {
        if (!globalThis.GOOJE_BRIDGE) return resolve(null)

        let sended = false
        if (comchan_version == 'v1') {
            sended = comchan_request_v1(
                { kind: 'theme_set', dark_mode: theme == 'dark' },
                res => {
                    resolve(res.kind == 'ok')
                }
            )
        }
        if (!sended) resolve(null)
    })
}

export async function native_geo_app_list(): Promise<GeoApp[] | null> {
    return new Promise(resolve => {
        if (!globalThis.GOOJE_BRIDGE) return resolve(null)

        let sended = false
        if (comchan_version == 'v1') {
            sended = comchan_request_v1({ kind: 'geo_app_list' }, res => {
                if (res.kind == 'geo_app_list') resolve(res.apps)
                else resolve(null)
            })
        }
        if (!sended) resolve(null)
    })
}

export async function native_open_geo_app(
    latitude: number,
    longitude: number,
    package_name?: string
): Promise<boolean | null> {
    return new Promise(resolve => {
        if (!globalThis.GOOJE_BRIDGE) return resolve(null)

        let sended = false
        if (comchan_version == 'v1') {
            sended = comchan_request_v1(
                { kind: 'open_geo_app', latitude, longitude, package_name },
                res => {
                    resolve(res.kind == 'ok')
                }
            )
        }
        if (!sended) resolve(null)
    })
}

export async function native_is_notifications_enabled(): Promise<
    boolean | null
> {
    return new Promise(resolve => {
        if (!globalThis.GOOJE_BRIDGE) return resolve(null)

        let sended = false
        if (comchan_version == 'v1') {
            sended = comchan_request_v1(
                { kind: 'notification_status' },
                res => {
                    if (res.kind == 'notification_status')
                        resolve(res.is_enabled)
                    else resolve(null)
                }
            )
        }
        if (!sended) resolve(null)
    })
}

export async function native_open_notification_settings(): Promise<
    boolean | null
> {
    return new Promise(resolve => {
        if (!globalThis.GOOJE_BRIDGE) return resolve(null)

        let sended = false
        if (comchan_version == 'v1') {
            sended = comchan_request_v1(
                { kind: 'open_notification_settings' },
                res => {
                    resolve(res.kind == 'ok')
                }
            )
        }
        if (!sended) resolve(null)
    })
}
